import React from 'react'
import NavBar from '../components/NavBar'
import Slider from "../components/Slider";
import '../css/NavBar.scss'
import WhoWeAre from '../components/WhoWeAre';
import SchoolMission from "../components/SchooolMission";
import Programs from "../components/Programs";
import Testimonials from '../components/Testimonials';
import SummerCamp from '../components/SummerCamp';
import CareersTeaser from '../components/CareersTeaser';
import Footer from "../components/Footer";
const IndexPage = () => {
  return (
    <div className='main-container'>
        <NavBar/>
        <Slider/>
        <WhoWeAre/>
        <SchoolMission/>
        <Programs/>
        <SummerCamp/>
        <CareersTeaser/>
        <Testimonials/>
        <Footer/>
        {/* 
       
     
      
      
         */}
        {/* <IndexPageApplyAdmission/>
     
      
        <IndexPageVirtualTourSection/>
        <Counter/> */}

    </div>
  )

}

export default IndexPage
